import { render, staticRenderFns } from "./PgaValutazioneOffertaTotaliOffertaDetails.vue?vue&type=template&id=564181ba&"
import script from "./PgaValutazioneOffertaTotaliOffertaDetails.vue?vue&type=script&lang=ts&"
export * from "./PgaValutazioneOffertaTotaliOffertaDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VCol,VContainer,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('564181ba')) {
      api.createRecord('564181ba', component.options)
    } else {
      api.reload('564181ba', component.options)
    }
    module.hot.accept("./PgaValutazioneOffertaTotaliOffertaDetails.vue?vue&type=template&id=564181ba&", function () {
      api.rerender('564181ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/ValutazioneOfferta/Components/PgaValutazioneOffertaTotaliOffertaDetails.vue"
export default component.exports